import React, { Fragment } from "react";
import "../../styles/footer.scss";
import { logo } from "../../assests/imageModule/image";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin } from "lucide-react"; // Lucide icons

const Footer = () => {
  return (
    <Fragment>
      <section className="footer_wrapper">
        <div className="container">
          <div className="footer_content">
            <div className="logo">
              <img src={logo} alt="footer_logo" width="120" height="auto" />
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "mailto:support@saajfarms.in";
                }}
              >
                <span>Email: </span> <span>support@saajfarms.in</span>
              </Link>
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "tel:+8950668555";
                }}
                style={{ marginTop: "12px" }}
              >
                <span>Call: </span> <span>+91 8950668555</span>
              </Link>
            </div>
            <div className="useful_links">
              <ul>
                <h2>Policies</h2>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/shipping-policy">Shipping Policy</Link>
                </li>
                <li>
                  <Link to="/refund-policy">Refund Policy</Link>
                </li>
                <li>
                  <Link to="/term-condition">Terms & Conditions</Link>
                </li>
              </ul>
            </div>
            <div className="useful_links">
              <ul>
                <h2>Useful Links</h2>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <Link to="/our-story">Our Story</Link>
                </li>
                <li>
                  <Link to="/blogs">Blogs</Link>
                </li>
              </ul>
            </div>
            <div className="social_media">
              <h2>Connect with us :</h2>
              <ul>
                <li>
                  <a
                    href="https://www.instagram.com/saajfarms?igsh=MWZicW1ucjg0OGF6Ng=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Instagram size={22} strokeWidth={1.8} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/share/1FSAqgZeXZ/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Facebook size={22} strokeWidth={1.8} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/saaj-farms/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Linkedin size={22} strokeWidth={1.8} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <p>Copyright © SAAJ FARMS. All rights reserved</p>
        </div>
      </section>
    </Fragment>
  );
};

export default Footer;
